export default "__VITE_ASSET__IYhU8yMW__"